import React, { useState, useEffect } from "react";

import { Row, Col, Button, Input } from "antd";
import {
  CloseOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";

import ArtistInResidencySearchResult from "./ArtistInResidencySearchResult";
// language context
import LocalizationContext from "../../../../localization/LocalizationContext";

import { useQuery } from "react-query";

import artistsSearchRequests from "../../../../services/helpers/search/artists-search";
import tagsRequests from "../../../../services/helpers/tagsquery";

// icons
import { ReactComponent as CrossBtn } from '../../../../icons/cross.svg';

export default function ArtistInResidencySection4(props) {
  const { t, i18n } = React.useContext(LocalizationContext);

  // filter thing
  let [filterType, setFilterType] = useState(null);
  let [showFilterBar, setShowFilterBar] = useState(false);

  let [currentSorting, setCurrentSorting] = useState('DESC')

  let [tagList, setTagList] = useState(null);
  let [yearList, setYearList] = useState(null);

  let [totalData, setTotalData] = useState([]);

  let [searchKeyword, setSearchKeyword] = useState("");
  let [selectedYear, setSelectedYear] = useState(null)
  let [selectedTag, setSelectedTag] = useState(null)

  let [pagination, setPagination] = useState({
    start: 0,
    limit: 4,
    step: 4,
    page: 1,
    isNextPageAvailable: true,
  });

  let queryDataGetYears = {
    resource: "years",
  };
  const yearListQuery = useQuery(["getAllYears", queryDataGetYears], () =>
    tagsRequests.getAllYears(queryDataGetYears)
  );

  let queryDataGetTags = {
    resource: "tag-types",
    param: "type",
    string: "artists_tags",
    language: i18n.language
  };
  const programsTags = useQuery(["programTags", queryDataGetTags], () =>
    tagsRequests.getTagTypeByName(queryDataGetTags)
  );
  useEffect(() => {
    let tempTagList = [];
    if (programsTags.data && programsTags.data.length > 0) {
      let x = programsTags.data[0].tags;
      let _filteredTagsByLanguage = x.filter((tagItem) => tagItem.language === i18n.language)
      tempTagList = _filteredTagsByLanguage.map((tagItem) => {
        return tagItem.tagName;
      });
    }
    setTagList(tempTagList);
  }, [programsTags.data]);

  // effect to set the lsit  of  all  years
  //
  useEffect(() => {
    let tempYearList = [];
    if (yearListQuery.data && yearListQuery.data.length > 0) {
      let x = yearListQuery.data;
      tempYearList = x.map((item) => {
        return item.year;
      });
    }
    setYearList(tempYearList);
  }, [yearListQuery.data]);

  useEffect(() => {
    filterForKeyword('')
  }, [])



  // clear filter
  let clearFilter = () => {
    setSearchKeyword('')
    setCurrentSorting('DESC')
    setSelectedYear(null)
    setSelectedTag(null)
  };
  // pagination
  let handlePagination = () => {
    let paginateData = [...totalData]

    // clearFilter();
    let totalrows = paginateData.length;
    let x = pagination;
    if (x.isNextPageAvailable) {
      setPagination({
        ...x,
        start: x.start,
        limit: x.limit + x.step,
        page: x.page + 1,
      });
    }
    if (totalrows < x.limit) {
      setPagination({
        ...x,
        isNextPageAvailable: false,
      });
    }
  };

  const closeShowFilterBar = () => {
    setShowFilterBar(false);
    setFilterType(null)
  };
  const showFilterBarSection = () => {
    setShowFilterBar(true);
  };


  const filterForKeyword = () => {
    let queryData = {
      lang: i18n.language,
      string: searchKeyword,
      start: pagination.start,
      limit: pagination.limit,
      sortType: currentSorting
    };
    let response = artistsSearchRequests.searchArtists(queryData, 'keyword')
    response.then(res => {
      if (res) {
        setTotalData(res);
      }
    })
  }
  const filterForTag = () => {
    let queryData = {
      lang: i18n.language,
      param: selectedTag,
      start: pagination.start,
      limit: pagination.limit,
      sortType: currentSorting
    };
    let response = artistsSearchRequests.searchArtists(queryData, 'tag')
    response.then(res => {
      if (res) {
        setTotalData(res);
      }
    })
  }
  const filterForYear = () => {
    // query based on year
    let queryData = {
      lang: i18n.language,
      param: selectedYear,
      start: pagination.start,
      limit: pagination.limit,
      sortType: currentSorting
    }
    let response = artistsSearchRequests.searchArtists(queryData, 'year')
    response.then(res => {
      if (res) {
        setTotalData(res);
      }
    })
  }
  const filterForKeywordAndYear = () => {
    let queryData = {
      lang: i18n.language,
      param: selectedYear,
      string: searchKeyword,
      start: pagination.start,
      limit: pagination.limit,
      sortType: currentSorting
    }
    let response = artistsSearchRequests.searchArtists(queryData, 'keywordYear')
    response.then(res => {
      if (res) {
        setTotalData(res);
      }
    })
  }
  const filterForKeywordAndTag = () => {
    let queryData = {
      lang: i18n.language,
      param: selectedTag,
      string: searchKeyword,
      start: pagination.start,
      limit: pagination.limit,
      sortType: currentSorting
    }
    let response = artistsSearchRequests.searchArtists(queryData, 'keywordTag')
    response.then(res => {
      if (res) {
        setTotalData(res);
      }
    })
  }
  const filterForTagAndYear = () => {
    let queryData = {
      lang: i18n.language,
      param: selectedTag,
      secondParam: selectedYear,
      start: pagination.start,
      limit: pagination.limit,
      sortType: currentSorting
    }
    let response = artistsSearchRequests.searchArtists(queryData, 'tagYear')
    response.then(res => {
      if (res) {
        setTotalData(res);
      }
    })
  }
  const filterForKeywordAndTagAndYear = () => {
    let queryData = {
      lang: i18n.language,
      string: searchKeyword,
      param: selectedTag,
      secondParam: selectedYear,
      start: pagination.start,
      limit: pagination.limit,
      sortType: currentSorting
    }
    let response = artistsSearchRequests.searchArtists(queryData, 'keywordTagYear')
    response.then(res => {
      if (res) {
        setTotalData(res);
      }
    })
  }

  const initiateSearch = () => {
    // usecases
    if (searchKeyword.length > 0) {
      if (!selectedTag && !selectedYear) {
        filterForKeyword()
      }
      if (!selectedTag && selectedYear) {
        filterForKeywordAndYear()
      }
      if (selectedTag && !selectedYear) {
        filterForKeywordAndTag()
      }
      if (selectedTag && selectedYear) {
        filterForKeywordAndTagAndYear()
      }
    } else {
      if (selectedTag && !selectedYear) {
        filterForTag()
      }
      if (!selectedTag && selectedYear) {
        filterForYear()
      }
      if (selectedTag && selectedYear) {
        filterForTagAndYear()
      }
      if (!selectedTag && !selectedYear) {
        filterForKeyword()
      }
    }
  }
  useEffect(() => {
    initiateSearch()
  }, [selectedTag, selectedYear, searchKeyword, currentSorting, pagination.limit, i18n.language])

  return (
    <div>
      <div className="artistinresidencysection4__container">
        <Row>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            <p className="artistinresidencysection4__title">
              {t("Former guest artists and events")} :{" "}
            </p>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            <div className="artistinresidencysection4__search-box">
              <Input
                onPressEnter={(e) => {
                  setSearchKeyword(e.target.value.trim());
                }}
                value={searchKeyword}
                onChange={(e) => {
                  setSearchKeyword(e.target.value);
                }}
                placeholder={`${t("Search")}`}
                className="placeholder-f-s-1-2em"

              />
              <div className="flex-row-align-items-center">
                {/* <Button
                  className="search-filter"
                  onClick={() => {
                    showFilterBarSection();
                    clearFilter();
                    setFilterType("tag");
                  }}
                >
                  {t("Filter")}
                </Button> */}
                <Button
                  className={
                    filterType === "tag"
                      ? "search-filter-active"
                      : "search-filter"
                  }
                  onClick={() => {
                    if (filterType === "tag") {
                      closeShowFilterBar();
                      return
                    }
                    showFilterBarSection();
                    setFilterType("tag");
                  }}
                >
                  {t("Filter")}
                </Button>
                <Button
                  className={
                    filterType === "year"
                      ? "search-filter-active mar-l-10"
                      : "search-filter mar-l-10"
                  }
                  onClick={() => {
                    if (filterType === "year") {
                      closeShowFilterBar();
                      return
                    }
                    showFilterBarSection();
                    setFilterType("year");
                  }}
                >
                  {t("Year")}
                </Button>

                <span className="mar-l-10 fs-1-3em">
                  <DownOutlined onClick={() => { setCurrentSorting('DESC') }}
                    className={currentSorting === 'DESC' ? 'sort-btn-active' : 'sort-btn'}
                  />
                </span>
                <span className="fs-1-3em mar-l-10 ">
                  <UpOutlined onClick={() => { setCurrentSorting('ASC') }}
                    className={currentSorting === 'ASC' ? 'sort-btn-active' : 'sort-btn'}
                  />
                </span>

              </div>
            </div>
          </Col>
          {showFilterBar && (
            <>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
                xl={{ span: 24 }}
                xxl={{ span: 24 }}
              >
                {filterType === "tag" && (
                  <div className="flex-row-justify-space-between">
                    <div className="tag-list">
                      {tagList.map((tag) => {
                        return (
                          <p
                            key={tag}
                            className={
                              selectedTag === tag
                                ? "tag-item-active mar-b-10"
                                : "tag-item mar-b-10"
                            }
                            onClick={() => {
                              if (selectedTag === tag) {
                                setSelectedTag(null)
                                return
                              }
                              setSelectedTag(tag)
                            }}
                          >
                            <span className="uppercasetext">{t(`${tag}`)}</span>
                          </p>
                        );
                      })}
                    </div>
                    <div className="possibilitiessearch__filter-close">
                      <CloseOutlined
                        className="closebtn"
                        onClick={() => {
                          closeShowFilterBar();
                          setFilterType(null)
                          clearFilter();
                        }}
                      />
                    </div>
                  </div>
                )}
                {filterType === "year" && (
                  <div className="flex-row-justify-space-between ">
                    <div className="tag-list">
                      {yearList.map((year) => {
                        return (
                          <p
                            key={year}
                            className={
                              selectedYear === year
                                ? "tag-item-active mar-b-10"
                                : "tag-item mar-b-10"
                            }
                            onClick={() => {
                              if (selectedYear === year) {
                                setSelectedYear(null)
                                return
                              }
                              setSelectedYear(year)
                            }}
                          >
                            {t(`${year}`)}
                          </p>
                        );
                      })}
                    </div>
                    <div className="previousprogramssearch____filter-close">
                      <CloseOutlined
                        className="closebtn"
                        onClick={() => {
                          closeShowFilterBar();
                          setFilterType(null)
                          clearFilter();
                        }}
                      />
                    </div>
                  </div>
                )}
              </Col>
              <Col span={24}>

              </Col>
            </>
          )}
          {/* <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            <div className="flex-row-justify-flex-end">
              <span className="artistinresidencysection4__text mar-r-10">
                Sort:
              </span>{" "}
              <Button className="btn-primary-hks">Ascending</Button>
              <Button className="btn-primary-hks  mar-l-10">Descending</Button>
            </div>
          </Col> */}
        </Row>
      </div>

      {/* {..... && <p>{t("Searching")}...</p>} */}
      {totalData && (
        <ArtistInResidencySearchResult
          filteredData={totalData}
          pagination={pagination}
          handlePagination={handlePagination}
          t={t}
        />
      )}
    </div>
  );
}
